export const shadows = {
  outline: '0 0 0 3px #C8B4F8',
};
